export function normalizeAumValue(value) {
    if (value == null || (typeof value === 'string' && value.trim() === '')) return null;
    const numericValue = Number(value);
    return Number.isFinite(numericValue) ? numericValue : null;
}
